import * as React from 'react'

import { FirstName, LastName, PhoneNumberInput as PhoneNumber } from '@grandvisionhq/forms'
import { FormSlotType } from '@grandvisionhq/lib-form-slots'
import { useIntl } from '@grandvisionhq/state'

import { INTL_DEFAULTS } from '../../configuration/intl'
import { countriesOrder } from '../../configuration/phone-number-input'
import { DateOfBirth } from './DateOfBirth'

export const PersonalDetailsForm: FormSlotType = () => {
  const { getLabel } = useIntl()

  return (
    <>
      <FirstName
        required
        label={getLabel('checkout.contact.firstName')}
        errorMessage={getLabel('checkout.contact.firstName.errorMessage')}
      />
      <LastName
        required
        label={getLabel('checkout.contact.lastName')}
        errorMessage={getLabel('checkout.contact.lastName.errorMessage')}
      />
      <PhoneNumber
        id="phone"
        data-t="phone-number"
        label={getLabel('checkout.contact.phoneNumber')}
        required
        hideAsteriskSign={false}
        initialState={{
          value: '',
        }}
        defaultCountry={INTL_DEFAULTS.country}
        localeForTranslations={INTL_DEFAULTS.locale}
        countriesOrder={countriesOrder}
        errorMessage={getLabel('checkout.contact.phoneNumber.errorMessage')}
        optionalText={getLabel('checkout.form.field.optional')}
      />
      <DateOfBirth />
    </>
  )
}
